/** @jsxRuntime classic */
/** @jsx jsx */
import { useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import AdvancedSettingsMenu from './AdvancedSettingsMenu';
import FolderLocation from './FolderLocation';

import { useUserQuery } from '../../actions/UserActions';
import { useFolderPrefix } from '../../utils/hooks';
import { useFolderOrganizationQuery } from '../../actions/FolderActions';

export default function UploadSettings({
  settings,
  setSettings,
  disabled,
  nameEdit = false,
}) {
  const { user } = useUserQuery();
  const { folderPrefix: initialFolderPrefix, isRootFolder } = useFolderPrefix({
    organization: user.workspace,
  });
  const { folders: _folders, isFetching } = useFolderOrganizationQuery({
    organizationId: user?.workspace?.id,
    folderPrefix: initialFolderPrefix,
    onlyEditAccess: true,
  });

  const folders = _folders?.filter((x) => !x.user_fallback);

  useEffect(() => {
    if (settings.folderPrefix || isFetching) return;

    if (folders?.length && isRootFolder) {
      const first = folders[0];
      setSettings((prev) => ({
        ...prev,
        folderPrefix: `${first.folder_prefix}${first.id}`,
      }));
    } else {
      setSettings((prev) => ({
        ...prev,
        folderPrefix: initialFolderPrefix,
      }));
    }
  }, [
    initialFolderPrefix,
    settings.folderPrefix,
    folders,
    settings,
    isFetching,
    isRootFolder,
  ]);

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
      `}
    >
      <FolderLocation
        currentFolderPrefix={settings.folderPrefix}
        onChange={(e) => setSettings((prev) => ({ ...prev, folderPrefix: e }))}
        disabled={disabled}
        asButton
      />
      <AdvancedSettingsMenu
        numSpeakers={settings.numSpeakers}
        language={settings.language}
        name={settings.name}
        setSetting={(key, value) =>
          setSettings((prev) => ({ ...prev, [key]: value }))
        }
        disabled={disabled}
        outputFormat={settings.outputFormat}
        nameEdit={nameEdit}
      />
    </div>
  );
}
